import { Component, OnInit } from '@angular/core';
import { UserSharedService } from '../../services/user-shared.service';

@Component({
  selector: 'idp-custom-alert',
  templateUrl: './custom-alert.component.html'
 
})
export class CustomAlertComponent implements OnInit {

    constructor(public _shared: UserSharedService) {
    }

    ngOnInit() {
    }
    close(i:number) {
        console.log("close clicked");
        this._shared.customMessageConfig.splice(i, 1);
    }
    customButtonClick(i: number) {
        console.log("custom button clicked");
        //  this._baseService._app.customClick.next(i + 1);
        this._shared.setCustomclickStream();
        
    }
}
